import { Form, Formik } from "formik";
import React from "react";
import TogglePushBtn from "../../../../components/Universal/TogglePushBtn.component";
import DropDownInput from "../../../../components/Universal/DropDownInput.component";

import { ReactComponent as PersonInMobileIcon } from "../../../../assets/Icons/Universal/PersonInMobile.svg";
import { ReactComponent as PersonIcon } from "../../../../assets/Icons/Universal/Person.svg";
import { ReactComponent as PlusBtnIcon } from "../../../../assets/Icons/Universal/PlusIcon.svg";

import AddProgramSubject from "../../../../components/PagesComponents/Operational/Academic/Programs/AddProgramSubject.component";
import FormInput from "../../../../components/Universal/FormInput.component";
import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import FilterBtn from "../../../../components/Universal/FilterBtn.component";
const Body = ({ filter, setFilter, classesFilter, setClassesFilter }) => {
  return (
    <section className="programDetails flex-col align-start justify-start g-1 pr-1">
      <PageHeader
        renderCustomElement={
          <div className="flex-row align-center justify-start g-05">
            <TogglePushBtn
              type="radio"
              setVal={(val) =>
                setFilter({
                  ...filter,
                  gender: val.toLowerCase(),
                })
              }
              name="examreportToggle"
              value={filter.gender}
              icon={
                <PersonIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="All"
            />
            <TogglePushBtn
              type="radio"
              setVal={(val) =>
                setFilter({
                  ...filter,
                  gender: val.toLowerCase(),
                })
              }
              name="examreportToggle"
              value={filter.gender}
              icon={
                <PersonInMobileIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="Boys"
            />
            <TogglePushBtn
              type="radio"
              setVal={(val) =>
                setFilter({
                  ...filter,
                  gender: val.toLowerCase(),
                })
              }
              name="examreportToggle"
              value={filter.gender}
              icon={
                <PersonInMobileIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="Girls"
            />
            <FilterBtn
              btnTitle={"Filter"}
              filterArray={[
                "Class I",
                "Class II",
                "Class III",
                "Class IV",
                "Class V",
              ]}
              setFilteredData={(val) => setClassesFilter(val)}
              filteredData={classesFilter}
            />
          </div>
        }
        title={"Programs & subjects for class 5"}
      />

      <div className="flex-row g-1">
        <div
          className=" flex-col align-start justify-start back-white radius-10 p-2"
          style={{ width: "50vw" }}
        >
          <Formik
            initialValues={{
              programFor: "",
              boardName: "",
              affiliation: "",
              academicMode: "",
              className: "",
              allotedSeats: "",
              section: "",
              filledSeats: "",
              programs: [],
            }}
            onSubmit={(values) => {
              console.log(values);
            }}
          >
            {({ touched, setFieldValue, errors, setTouched, values }) => {
              const removeProgram = (val) => {
                const output = values.programs.filter((data) => {
                  return data.id !== val.id;
                });
                setFieldValue("programs", output);
              };
              return (
                <Form>
                  <div
                    className="flex-col align-start justify-start g-2"
                    style={{ width: "40vw", gap: "1.5rem" }}
                  >
                    <div className="w-full flex-row align-center justify-between">
                      <div className="flex-row align-center justify-start g-2">
                        <h3 className="weight-500 t-20 poppins">
                          Add Programs
                        </h3>
                        <div className="flex-row align-center justify-start g-1">
                          <TogglePushBtn
                            type="radio"
                            setVal={(val) =>
                              setFieldValue("programFor", val.toLowerCase())
                            }
                            name="programFor"
                            value={values.programFor}
                            icon={
                              <PersonIcon
                                fill="white"
                                style={{ width: "1.3rem", height: "1.3rem" }}
                              />
                            }
                            icontype="svg"
                            label="All"
                          />
                          <TogglePushBtn
                            type="radio"
                            setVal={(val) =>
                              setFieldValue("programFor", val.toLowerCase())
                            }
                            name="programFor"
                            value={values.programFor}
                            icon={
                              <PersonInMobileIcon
                                fill="white"
                                style={{ width: "1.3rem", height: "1.3rem" }}
                              />
                            }
                            icontype="svg"
                            label="Boys"
                          />
                          <TogglePushBtn
                            type="radio"
                            setVal={(val) =>
                              setFieldValue("programFor", val.toLowerCase())
                            }
                            name="programFor"
                            value={values.programFor}
                            icon={
                              <PersonInMobileIcon
                                fill="white"
                                style={{ width: "1.3rem", height: "1.3rem" }}
                              />
                            }
                            icontype="svg"
                            label="Girls"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="programModalFormInputSec">
                      <DropDownInput
                        type="select"
                        name="boardName"
                        label="Board"
                        setFieldValue={(val) => setFieldValue("boardName", val)}
                        placeholder={"Choose Board"}
                        suggestionList={[
                          "board 1",
                          "board 2",
                          "board 3",
                          "board 4",
                          "board 4",
                          "board 4",
                          "board 4",
                          "board 4",
                          "board 4",
                          "board 4",
                          "board 4",
                          "board 4",
                          "board 4",
                        ]}
                        touched={touched}
                        errors={errors}
                        setTouched={(name, isTouched) =>
                          setTouched({ [name]: isTouched })
                        }
                      />

                      <FormInput
                        type="text"
                        name="affiliation"
                        touched={touched}
                        errors={errors}
                        label="Affiliation"
                        placeholder={"Enter affiliation or certification"}
                      />
                      <DropDownInput
                        type="select"
                        name="academicMode"
                        label="Mode"
                        setFieldValue={(val) =>
                          setFieldValue("academicMode", val)
                        }
                        placeholder={"Choose academic mode"}
                        suggestionList={["Online", "Offline"]}
                        touched={touched}
                        errors={errors}
                        setTouched={(name, isTouched) =>
                          setTouched({ [name]: isTouched })
                        }
                      />
                      <DropDownInput
                        type="select"
                        name="className"
                        label="Class"
                        setFieldValue={(val) => setFieldValue("className", val)}
                        placeholder={"Choose class name"}
                        suggestionList={["I", "II", "III"]}
                        touched={touched}
                        errors={errors}
                        setTouched={(name, isTouched) =>
                          setTouched({ [name]: isTouched })
                        }
                      />
                      <FormInput
                        type="text"
                        name="allotedSeats"
                        touched={touched}
                        errors={errors}
                        label="Alloted seats"
                        placeholder={"Enter total seat number"}
                      />
                      <DropDownInput
                        type="select"
                        name="section"
                        label="Section"
                        setFieldValue={(val) => setFieldValue("section", val)}
                        placeholder={"Choose class section"}
                        suggestionList={["A", "B", "C"]}
                        touched={touched}
                        errors={errors}
                        setTouched={(name, isTouched) =>
                          setTouched({ [name]: isTouched })
                        }
                      />
                      <FormInput
                        label="Filled seats"
                        type="number"
                        name="filledSeats"
                        touched={touched}
                        errors={errors}
                        placeholder={"Enter Filled seats (in number)"}
                      />
                    </div>
                    <hr color="#b0b0b0" />

                    <div className="flex-col align-start justify-start g-1">
                      <h3 className="t-18 color-grayColor poppins weight-500">
                        Subjects
                      </h3>
                      <div
                        style={{ height: "20vh" }}
                        className="scroll-y flex-col align-start justify-start pr-1"
                      >
                        <div className="flex-col align-start justify-start g-1 h-fit w-full">
                          {values.programs.map((program, index) => (
                            <AddProgramSubject
                              key={program.id} // Use unique ID as key
                              index={index}
                              program={program}
                              addNewProgram={(updatedProgram) => {
                                const updatedPrograms = [...values.programs];
                                updatedPrograms[index] = updatedProgram;
                                setFieldValue("programs", updatedPrograms);
                              }}
                              removeProgram={removeProgram} // Pass remove function to remove the component
                            />
                          ))}
                          <button
                            type="button"
                            className="transparentBtn flex-row w-fit align-center justify-center g-05"
                            onClick={() => {
                              const newProgram = {
                                id: Date.now(),
                                subjectName: "",
                                subjectType: "",
                                subjectCode: "",
                              };
                              setFieldValue("programs", [
                                ...values.programs,
                                newProgram,
                              ]);
                            }}
                          >
                            <PlusBtnIcon
                              fill="#6f944e"
                              style={{ width: "2rem", height: "2rem" }}
                            />
                            <span className="t-20 poppins">Add</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <button type="submit" className="actionBtn w-full p-1">
                      Update
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>

        <div
          className="test flex-col align-center justify-start g-05 radius-6 back-white p-1"
          style={{ width: "46%" }}
        >
          <h3 className="t-20 color-grayColor weight-500 poppins">Subjects curriculum</h3>
          <div className="programSubjects">
            
          </div>
        </div>
      </div>
    </section>
  );
};

export default Body;
